module.exports = __webpack_public_path__ + "static/media/logo.edd8a0c4.png";